/* eslint-disable no-use-before-define */
import React from 'react'
import onValidate_ from './validate'
import onSubmit from './submit'
import {initialValues} from './from-search-params'
import { getState } from '../../twd/twd'
export * from './to-search-params'

export const Context = React.createContext()

const state = getState('advanced_screener.search_form', {
    currentValues: initialValues
})

const onValidate = (values) => {
    let err = onValidate_(values)
    state.set({
        currentValues: values,
        errors: err
    })
    return err
}


export const ContextProvider = ({children}) => {
    return (
    <Context.Provider value={{
        state, onValidate, onSubmit
    }}>
    {children}
    </Context.Provider>
    )
}

export const useSearchForm = () => React.useContext(Context)